/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_No_ResultsInputs */

const en_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No search criteria yet.`)
};

const de_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Suchkriterien.`)
};

const fr_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun critère de recherche pour le moment.`)
};

const es_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay criterios de búsqueda.`)
};

const it_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun criterio di ricerca ancora.`)
};

const nl_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen zoekcriteria.`)
};

const pl_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak kryteriów wyszukiwania.`)
};

const fi_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä hakukriteerejä.`)
};

const da_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen søgekriterier endnu.`)
};

const sv_jobs_search_criteria_no_results = /** @type {(inputs: Jobs_Search_Criteria_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga sökkriterier ännu.`)
};

/**
* | output |
* | --- |
* | "No search criteria yet." |
*
* @param {Jobs_Search_Criteria_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_no_results = /** @type {((inputs?: Jobs_Search_Criteria_No_ResultsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_No_ResultsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_no_results(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_no_results(inputs)
	if (locale === "es") return es_jobs_search_criteria_no_results(inputs)
	if (locale === "it") return it_jobs_search_criteria_no_results(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_no_results(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_no_results(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_no_results(inputs)
	if (locale === "da") return da_jobs_search_criteria_no_results(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_no_results(inputs)
	return en_jobs_search_criteria_no_results(inputs)
});